/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetLocalityCrowdSizeRequestBody
 */
export interface SetLocalityCrowdSizeRequestBody {
    /**
     * 
     * @type {number}
     * @memberof SetLocalityCrowdSizeRequestBody
     */
    crowdSize: number;
}

export function SetLocalityCrowdSizeRequestBodyFromJSON(json: any): SetLocalityCrowdSizeRequestBody {
    return SetLocalityCrowdSizeRequestBodyFromJSONTyped(json, false);
}

export function SetLocalityCrowdSizeRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLocalityCrowdSizeRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'crowdSize': json['crowd_size'],
    };
}

export function SetLocalityCrowdSizeRequestBodyToJSON(value?: SetLocalityCrowdSizeRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'crowd_size': value.crowdSize,
    };
}

